import { Link } from "react-router-dom";

export default function RecruitGlanceLogo({
  to = "/",
  dark = false,
  showWordmark = true,
  className = "",
}) {
  const wordmarkClasses = dark ? "text-white" : "text-[#03140f]";

  return (
    <Link
      to={to}
      className={`inline-flex items-center gap-3 ${className}`}
    >
      <span
        className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#003d31] shadow-sm ring-1 ring-emerald-100/20"
        aria-hidden="true"
      >
        <img
          src="/media/recruitglance-mark-tight.png"
          alt="RecruitGlance"
          className="h-[4.4rem] w-[4.4rem] max-w-none object-contain"
        />
      </span>

      {showWordmark && (
        <span className={`text-xl font-bold tracking-tight ${wordmarkClasses}`}>
          RecruitGlance
        </span>
      )}
    </Link>
  );
}
